import React from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import Box from "@material-ui/core/Box";
import Tooltip from "@material-ui/core/Tooltip";
import HelpIcon from "@material-ui/icons/HelpOutline";

const styles = (theme) => ({
  wrapper: {
    display: "inline-flex",
    alignItems: "flex-start",
  },
  tooltip: {
    background: theme.palette.primary.contrastText,
    border: `1px solid ${theme.palette.secondary.lightGray}`,
    color: theme.palette.secondary.charcoal,
    boxShadow: theme.shadows[1],
    opacity: 1,
    fontSize: theme.typography.fontSize,
    lineHeight: 1.5,
    [theme.breakpoints.down("md")]: {
      paddingBottom: theme.spacing(2),
    },
  },
  icon: {
    fontSize: theme.typography.tooltipIcon.fontSize,
    marginLeft: theme.spacing(1),
    cursor: 'help',
  },
  label: {
    fontSize: theme.typography.tooltip.fontSize,
  },
  labelIcon: {
    fontSize: theme.typography.fontSize,
  },
});

const BaseTooltip = ({
  classes,
  labelComponent,
  helperText,
  placement,
  showTooltip,
  variant,
  boxProps,
}) => (
  <Box
    className={`${classes.wrapper} ${variant === 'label' && classes.label}`}
    {...boxProps}
  >
    {labelComponent}
    {showTooltip && (
      <Tooltip
        classes={{ tooltip: classes.tooltip }}
        placement={placement}
        title={helperText}
        disableFocusListener
      >
        <HelpIcon className={`${classes.icon} ${variant === 'label' && classes.labelIcon}`}/>
      </Tooltip>
    )}
  </Box>
);

BaseTooltip.propTypes = {
  labelComponent: PropTypes.node.isRequired,
  helperText: PropTypes.string.isRequired,
  placement: PropTypes.string,
  showTooltip: PropTypes.boolean,
  variant: PropTypes.string,
  boxProps: PropTypes.object,
};

BaseTooltip.defaultProps = {
  placement: 'top',
  showTooltip: true,
  variant: '',
  boxProps: {},
};


export default withStyles(styles, { withTheme: true })(BaseTooltip);


// WEBPACK FOOTER //
// ./src/components/BaseComponents/BaseTooltip/index.jsx